import { Template } from '@/models/drawing/drawingTypes.ts'

export const DEFAULT_TEMPLATE: Template = {
  id: 'bg-red',
  background: {
    type: 'image',
    value: '/drawing/bg-red-aquarell.jpg'
  },
  stylings: [
    {
      id: 'font-color',
      display: 'Schriftfarbe',
      target: 'text',
      color: '#a1845c'
    }
  ],
  elements: [
    {
      id: 'title-text',
      type: 'text',
      content: 'card.togetherMemory',
      uppercase: true,
      fontSize: 40,
      fontFamily: 'poppins',
      color: '#3F3F3F',
      textAlign: 'center',
      letterSpacing: 6,
      lineHeight: 1.2,
      stylings: ['font-color'],
      position: {
        top: '12%',
        width: '75%',
        left: '12.5%',
      }
    },
    {
      id: 'names-text',
      type: 'text',
      content: 'Laura & Thomas',
      fontSize: 180,
      fontFamily: 'dancing-script',
      color: '#3F3F3F',
      textAlign: 'center',
      lineHeight: 0.9,
      stylings: ['font-color'],
      position: {
        top: '25%',
        width: '75%',
        left: '12.5%',
      }
    },
    {
      id: 'qr-code',
      type: 'image',
      // src: '/drawing/fridaysnap-qr-code-placeholder.png',
      src: '/drawing/fridaysnap-qr-code-placeholder.png',
      alt: 'QR Code',
      position: {
        top: '45%',
        left: '30%',
        width: '40%',
      }
    },
    {
      id: 'memories-text',
      type: 'text',
      content: 'card.simplyScan',
      uppercase: true,
      fontSize: 40,
      fontFamily: 'poppins',
      color: '#3F3F3F',
      textAlign: 'center',
      letterSpacing: 6,
      lineHeight: 1.2,
      stylings: ['font-color'],
      position: {
        top: '75%',
        width: '75%',
        left: '12.5%',
      }
    },
    {
      id: 'day-text',
      type: 'text',
      content: 'card.ourDay',
      fontSize: 60,
      fontFamily: 'dancing-script',
      color: '#3F3F3F',
      textAlign: 'center',
      stylings: ['font-color'],
      position: {
        top: '82%',
        width: '75%',
        left: '12.5%',
      }
    },
  ]
}

const GOLD_TEMPLATE: Template = {
  id: 'bg-gold',
  background: {
    type: 'image',
    value: '/drawing/bg-gold-dye.jpg'
  },
  stylings: [
    {
      id: 'font-color',
      display: 'Schriftfarbe',
      target: 'text',
      color: '#e2c935'
    }
  ],
  elements: [
    {
      id: 'center-rect',
      type: 'rect',
      backgroundColor: 'white',
      position: {
        top: '15%',
        left: '15%',
        width: '70%',
        height: '70%',
      }
    },
    {
      id: 'title-text',
      type: 'text',
      content: 'card.togetherMemory',
      uppercase: true,
      fontSize: 40,
      fontFamily: 'poppins',
      color: '#3F3F3F',
      textAlign: 'center',
      letterSpacing: 6,
      lineHeight: 1.2,
      stylings: ['font-color'],
      position: {
        top: '18%',
        width: '75%',
        left: '12.5%',
      }
    },
    {
      id: 'names-text',
      type: 'text',
      content: 'Laura & Thomas',
      fontSize: 160,
      fontFamily: 'dancing-script',
      color: '#3F3F3F',
      textAlign: 'center',
      lineHeight: 0.9,
      stylings: ['font-color'],
      position: {
        top: '28%',
        width: '75%',
        left: '12.5%',
      }
    },
    {
      id: 'qr-code',
      type: 'image',
      // src: '/drawing/fridaysnap-qr-code-placeholder.png',
      src: '/drawing/fridaysnap-qr-code-placeholder.png',
      alt: 'QR Code',
      position: {
        top: '42%',
        left: '30%',
        width: '40%',
      }
    },
    {
      id: 'memories-text',
      type: 'text',
      content: 'card.simplyScan',
      uppercase: true,
      fontSize: 40,
      fontFamily: 'poppins',
      color: '#3F3F3F',
      textAlign: 'center',
      letterSpacing: 6,
      lineHeight: 1.2,
      stylings: ['font-color'],
      position: {
        top: '78%',
        width: '75%',
        left: '12.5%',
      }
    }
  ]
}

const WHITE_BLUE_TEMPLATE: Template = {
  id: 'bg-white',
  background: {
    type: 'image',
    value: '/drawing/white-blue-bg.webp'
  },
  stylings: [
    {
      id: 'font-color',
      display: 'Schriftfarbe',
      target: 'text',
      color: '#4A729C'
    }
  ],
  elements: [
    {
      id: 'title-text',
      type: 'text',
      content: 'card.welcomeToWedding',
      uppercase: true,
      fontSize: 60,
      fontFamily: 'poppins',
      color: '#3F3F3F',
      textAlign: 'right',
      letterSpacing: 10,
      lineHeight: 1.2,
      stylings: ['font-color'],
      position: {
        top: '10%',
        width: '75%',
        left: '12.5%',
      }
    },
    {
      id: 'names-text',
      type: 'text',
      content: 'Laura & Thomas',
      fontSize: 180,
      fontFamily: 'dancing-script',
      color: '#3F3F3F',
      textAlign: 'left',
      lineHeight: 0.9,
      stylings: ['font-color'],
      position: {
        top: '40%',
        width: '64%',
        left: '10%',
      }
    },
    {
      id: 'qr-code',
      type: 'image',
      // src: '/drawing/fridaysnap-qr-code-placeholder.png',
      src: '/drawing/fridaysnap-qr-code-placeholder.png',
      alt: 'QR Code',
      position: {
        top: '63%',
        left: '44%',
        width: '40%',
      }
    },
    {
      id: 'share-text',
      type: 'text',
      content: 'card.pleaseShare',
      uppercase: true,
      fontSize: 40,
      fontFamily: 'poppins',
      color: '#3F3F3F',
      textAlign: 'left',
      letterSpacing: 8,
      lineHeight: 1.2,
      stylings: ['font-color'],
      position: {
        top: '67%',
        width: '35%',
        left: '10%',
      }
    },
    {
      id: 'memories-text',
      type: 'text',
      content: 'card.simplyScan',
      uppercase: true,
      fontSize: 40,
      fontFamily: 'poppins',
      color: '#3F3F3F',
      textAlign: 'left',
      letterSpacing: 8,
      lineHeight: 1.2,
      stylings: ['font-color'],
      position: {
        top: '81%',
        width: '35%',
        left: '10%',
      }
    }
  ]
}

// Export as array for compatibility with existing code if needed
export const drawingTemplates = [DEFAULT_TEMPLATE, GOLD_TEMPLATE, WHITE_BLUE_TEMPLATE]
